import React from "react";
import { appSettings } from "core/config";
import { imageUrl } from "core/lib";

const Footer = ({
  conditionalDisplay = false,
}: {
  conditionalDisplay?: boolean;
}) => {
  const mcLogo = imageUrl("logos/multichoice.png");

  const termsAndConditionLinks = [
    {
      text: "Community",
      link: "#",
      openInNewWindow: true,
    },
    {
      text: "MultiChoice",
      link: "https://www.multichoice.com/",
      openInNewWindow: true,
    },
    {
      text: "Terms & Conditions",
      link: "https://www.dstv.co.za/legal/terms-and-conditions/",
      openInNewWindow: true,
    },
    {
      text: "Privacy & Cookie Notice",
      link: "https://www.multichoice.com/privacy-cookie-notice/",
      openInNewWindow: true,
    },
    {
      text: "Responsible Disclosure Policy",
      link: "https://www.multichoice.com/responsible-disclosure-policy/",
      openInNewWindow: true,
    },
    {
      text: "Copyright",
      link: "https://www.dstv.co.za/legal/copyright/",
      openInNewWindow: true,
    },
  ];

  const socialLinks = [
    {
      text: "Facebook",
      link: "https://www.facebook.com/DStvSouthAfrica/",
      iconClass: "icon-Facebook",
    },
    {
      text: "Twitter",
      link: "https://twitter.com/DStv",
      iconClass: "icon-Twitter",
    },
    {
      text: "Instagram",
      link: "https://www.instagram.com/DStvza/",
      iconClass: "icon-instagram",
    },
    {
      text: "YouTube",
      link: "https://www.youtube.com/user/DStvOnline",
      iconClass: "icon-YouTube",
    },
  ];

  if (!appSettings.isEnabled.headerAndFooter) {
    //if (conditionalDisplay && !appSettings.isEnabled.headerAndFooter) {
    return null;
  }

  const year = new Date().getFullYear();

  return (
    <footer className="dev">
      <nav>
        <div className="links">
          <a
            className="logo"
            href="https://www.multichoice.co.za/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={mcLogo} alt="Multichoice" />
          </a>

          <span>
            <ul>
              {termsAndConditionLinks.map((linkItem, index) => (
                <li key={index}>
                  <a
                    href={linkItem.link}
                    target={linkItem.openInNewWindow ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                  >
                    {linkItem.text}
                  </a>
                </li>
              ))}
            </ul>

            <p>© {year} MultiChoice (PTY) LTD. All rights reserved</p>
          </span>
        </div>

        <ul className="social-media-links">
          {socialLinks.map((socialLink, index) => (
            <li key={index}>
              <a
                href={socialLink.link}
                key={index}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className={socialLink.iconClass} title={socialLink.text}></i>
                <span className="sr-only">{socialLink.text}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
